import { createSlice } from "@reduxjs/toolkit";
import { getVOCList } from "./thunk";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { IOperator } from "api/types/_operator";


export interface IState {
  vocList: ResponseData<IOperator[]> & PaginationResponse | null,
  isVOCListLoading: boolean,
  isVOCListSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  vocList: null,
  isVOCListLoading: false,
  isVOCListSuccess: false,

  error: {},
};

const VOCListSlice = createSlice({
  name: "VOCList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get vocList
    builder.addCase(getVOCList.pending, (state: IState, action: any) => {
      state.isVOCListLoading = true
    });
    builder.addCase(getVOCList.fulfilled, (state: IState, action: any) => {
      state.vocList = action.payload.data;
      state.isVOCListSuccess = true;
      state.isVOCListLoading = false;
    });
    builder.addCase(getVOCList.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isVOCListSuccess = false;
      state.isVOCListLoading = false;
    });
  },
});

export default VOCListSlice.reducer;
